import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import LanguageSwitcher from '../../components/ui/LanguageSwitcher';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import toast from 'react-hot-toast';

const Login = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const { isRTL } = useTheme();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });



  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login({ email: formData.email, password: formData.password });
      toast.success(t('dashboard.welcome'));
      // Navigation is handled by the App component when currentUser changes
    } catch (error) {
      console.error('Login error:', error);
      toast.error(t('auth.invalid_credentials'));
    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="min-h-screen flex">
      {/* Left side - Login Form */}
      <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:px-20 xl:px-24">
        <div className="mx-auto w-full max-w-sm lg:w-96">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-primary-600 mb-2">Logistiat</h1>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              {t('auth.welcome_back')}
            </h2>
            <p className="text-sm text-gray-600 mb-8">
              {t('auth.sign_in_subtitle')}
            </p>
          </div>

          <div className="mt-8">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="email" className="label">
                  {t('accounting.email')}
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  className="input-field"
                  value={formData.email}
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label htmlFor="password" className="label">
                  {t('auth.password')}
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="input-field"
                  value={formData.password}
                  onChange={handleInputChange}
                />
              </div>

              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <input
                    id="rememberMe"
                    name="rememberMe"
                    type="checkbox"
                    className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                    checked={formData.rememberMe}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="rememberMe" className="ml-2 block text-sm text-gray-900">
                    {t('auth.remember_me')}
                  </label>
                </div>

                <div className="text-sm">
                  <button
                    type="button"
                    className="font-medium text-primary-600 hover:text-primary-500"
                  >
                    {t('auth.forgot_password')}
                  </button>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading}
                  className="w-full btn btn-primary flex justify-center items-center"
                >
                  {loading ? (
                    <LoadingSpinner size="sm" className="text-white" />
                  ) : (
                    t('auth.login_button')
                  )}
                </button>
              </div>
            </form>


          </div>
        </div>

        {/* Language Switcher */}
        <div className="mt-8 flex justify-center">
          <LanguageSwitcher />
        </div>
      </div>

      {/* Right side - Image/Illustration */}
      <div className="hidden lg:block relative w-0 flex-1">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600 to-primary-800 flex items-center justify-center">
          <div className="text-center text-white">
            <div className="text-6xl mb-4">🚛</div>
            <h3 className="text-2xl font-bold mb-2">
              {isRTL ? 'نظام إدارة اللوجستيات الشامل' : 'Complete Logistics Management'}
            </h3>
            <p className="text-primary-100 max-w-md">
              {isRTL 
                ? 'إدارة الشحنات والعملاء والفواتير والمحاسبة في مكان واحد'
                : 'Manage shipments, clients, invoicing, and accounting all in one place'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login; 